import React from 'react'

export default class PrintExplanationText extends React.Component {

  render() {
    const {option, collaborationresponse} = this.props
    const questionHasCountedCollaboration = collaborationresponse ? (Object.keys(collaborationresponse).length > 0 ?
      ('id' in option ? Object.keys(collaborationresponse).includes(option.id.toString()) : false) : false) : false

    return (
      <React.Fragment key={option.id + 'Toelichting'}>
        {questionHasCountedCollaboration && collaborationresponse[option.id].map((collaborator, i) => {
          return <tr key={option.id + i}>
            <td width="55%">{collaborator.firstName + ' ' + collaborator.lastName}</td>
            <td width="45%">{(collaborator.answer.stringValue ? collaborator.answer.stringValue : ' ')}</td>
          </tr>
        })}
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/PrintExplanationText.js